import type { ContentTypeObject, CustomHtmlElement } from '../../types/pbTypes';
import type { PbBanner } from '../../types/pbBlocks';
import {
    getBackgroundImages,
    getBorder,
    getPadding,
    getTextAlign,
    parseStyleString,
    getButtonLinkType,
    getButtonType,
    getCssClasses,
    getMargin,
    getIsHidden,
    getVideoOptions,
} from '../utils';

export type BannerType = ContentTypeObject & PbBanner;

/**
 * Aggregates the configuration of a banner element.
 * @param node
 * @param props
 */
export function bannerConfigAggregator(node: CustomHtmlElement, props?: any): BannerType {
    const style = parseStyleString(node?.attributes.style);

    const wrapperElement = node.querySelector('[data-element="wrapper"]') as unknown as CustomHtmlElement | null;
    const wrapperStyles = parseStyleString(wrapperElement?.attributes.style);

    const overlayElement = node.querySelector('[data-element="overlay"]') as unknown as CustomHtmlElement | null;
    const overlayStyles = parseStyleString(overlayElement?.attributes.style);

    const linkElement = node.querySelector('a[data-element="link"]') as unknown as CustomHtmlElement | null;
    const buttonElement = node.querySelector('[data-element="button"]') as unknown as CustomHtmlElement | null;

    const contentElement = node.querySelector('[data-element="content"]') as unknown as CustomHtmlElement | null;

    const buttonBackgroundColour = node.attributes['background_colour'];
    const buttonTextColour = node.attributes['text_colour'];
    const showButton = node.attributes['data-show-button'];
    const showOverlay = node.attributes['data-show-overlay'];

    const content = contentElement?.innerHTML;

    const isPoster = props.appearance === 'poster';

    return {
        ...getCssClasses(node),
        ...getMargin(style),
        ...getIsHidden(style),
        ...getTextAlign(wrapperStyles),
        ...getBorder(wrapperStyles),
        ...getPadding(isPoster ? overlayStyles : wrapperStyles),
        ...getBackgroundImages(wrapperElement, wrapperStyles),
        ...getVideoOptions(wrapperElement),
        altText: overlayElement?.attributes['aria-label'],
        backgroundColor: wrapperStyles?.backgroundColor,
        backgroundType: wrapperElement?.attributes['data-background-type'],
        buttonText: buttonElement?.textContent,
        buttonType: getButtonType(buttonElement?.classNames),
        content: content,
        link: linkElement?.attributes['href'],
        linkType: getButtonLinkType(linkElement?.attributes['data-link-type']),
        minHeight: isPoster ? overlayStyles?.minHeight : wrapperStyles?.minHeight,
        openInNewTab: linkElement?.attributes['target'] === '_blank',
        overlayColor: overlayElement?.attributes['data-overlay-color'],
        showButton,
        showOverlay,
        titleText: overlayElement?.attributes['title'],
        uniqueID: node.attributes['data-pb-style'],
        buttonTextColour,
        buttonBackgroundColour,
    };
}
